const hsmVariables = Object.freeze({
  'NOME': 0,
  'TELEFONE': 1,
  'EMAIL': 2
})

export default hsmVariables



// WEBPACK FOOTER //
// ./src/views/private/configurations/hsm/components/enums/enumVariaveisHsm.js